export const ACCOUNT_LINKING_TOAST_DELAY = 250;
